import client from './client';

export const listRoles = () =>
  client.get('/rbac/roles').then((r) => r.data);

export const getRole = (id) =>
  client.get(`/rbac/roles/${id}`).then((r) => r.data);

export const createRole = (data) =>
  client.post('/rbac/roles', data).then((r) => r.data);

export const updateRole = (id, data) =>
  client.put(`/rbac/roles/${id}`, data).then((r) => r.data);

export const deleteRole = (id) =>
  client.delete(`/rbac/roles/${id}`).then((r) => r.data);

export const listPermissions = () =>
  client.get('/rbac/permissions').then((r) => r.data);

export const createPermission = (data) =>
  client.post('/rbac/permissions', data).then((r) => r.data);

export const updatePermission = (id, data) =>
  client.put(`/rbac/permissions/${id}`, data).then((r) => r.data);

export const deletePermission = (id) =>
  client.delete(`/rbac/permissions/${id}`).then((r) => r.data);

// Single-role permission grant/revoke. Use these for the role-detail UI
// where the user is editing one role at a time; the bulk endpoint
// (POST /rbac/bulk/assign-permissions) is for fan-out across many roles.
export const grantRolePermission = (roleId, permissionId, conditions) =>
  client
    .post(`/rbac/roles/${roleId}/permissions`, {
      permission_id: permissionId,
      conditions: conditions || null,
    })
    .then((r) => r.data);

export const revokeRolePermission = (roleId, permissionId) =>
  client
    .delete(`/rbac/roles/${roleId}/permissions/${permissionId}`)
    .then((r) => r.data);

export const getUserRoles = (userId) =>
  client.get(`/rbac/users/${userId}/roles`).then((r) => r.data);

export const assignRole = (userId, data) =>
  client.post(`/rbac/users/${userId}/roles`, data).then((r) => r.data);

export const removeUserRole = (userId, roleId) =>
  client.delete(`/rbac/users/${userId}/roles/${roleId}`).then((r) => r.data);
